var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIraq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8506C24.8366 32.8506 32 25.6871 32 16.8506C32 8.01403 24.8366 0.850586 16 0.850586C7.16344 0.850586 0 8.01403 0 16.8506C0 25.6871 7.16344 32.8506 16 32.8506Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.850586C9.12055 0.850586 3.25587 5.19259 0.995178 11.2854H31.0049C28.7441 5.19259 22.8794 0.850586 16 0.850586Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8508C22.8794 32.8508 28.7441 28.5088 31.0048 22.416H0.995178C3.25587 28.5088 9.12055 32.8508 16 32.8508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 15.8072C12.1652 15.8072 12.1566 15.8078 12.1479 15.8079V15.8072H9.08931C9.24437 15.2081 9.788 14.7637 10.4348 14.7637V12.6768C8.51687 12.6768 6.95656 14.2371 6.95656 16.155V17.8594V17.8942H12.1479H12.1739C12.3657 17.8942 12.5217 18.0503 12.5217 18.242V18.9376H5.56519V21.0246H14.6087V18.2419C14.6087 16.8994 13.5164 15.8072 12.1739 15.8072Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 18.9376V12.6768H15.3044V21.0246H18.7826V18.9376H17.3913Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3478 18.9377V12.6768H22.2609V18.9377H21.5652V16.8508H19.4782V21.0247H25.7391V18.9377H24.3478Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIraq);
export default __webpack_public_path__ + "static/media/flag_iraq.f6a05ba1972517043eb67e1c63b0b7ae.svg";
export { ForwardRef as ReactComponent };